import type { Question } from '../../types';

// ---------------------------------------------------------------------------
// Home Health Care Supplement
// Conditioned on industry_type eq 'home_health'
// ---------------------------------------------------------------------------

const C = [{ field: 'industry_type', operator: 'eq' as const, value: 'home_health' }];

export const homeHealthQuestions: Question[] = [
  {
    id: 'hh_services',
    text: 'Which services do you provide?',
    section: 'supplement',
    group: 'hh_operations',
    sort_order: 10,
    field_type: 'multiselect',
    required: true,
    options: [
      { value: 'skilled_nursing', label: 'Skilled nursing' },
      { value: 'personal_care', label: 'Personal care / companion / homemaker' },
      { value: 'therapy', label: 'Physical / occupational / speech therapy' },
      { value: 'hospice', label: 'Hospice / palliative' },
      { value: 'home_infusion', label: 'Home infusion / IV' },
      { value: 'staffing', label: 'Medical staffing' },
    ],
    field_path: 'supplement.home_health.services',
    conditions: C,
    tags: ['supplement', 'home_health'],
  },
  {
    id: 'hh_annual_revenue',
    text: 'Annual gross revenue',
    section: 'supplement',
    group: 'hh_financials',
    sort_order: 20,
    field_type: 'currency',
    prefix: '$',
    placeholder: '900000',
    required: true,
    field_path: 'supplement.home_health.annual_revenue',
    conditions: C,
    tags: ['supplement', 'home_health'],
  },
  {
    id: 'hh_caregivers',
    text: 'Number of caregivers / clinical staff',
    section: 'supplement',
    group: 'hh_employees',
    sort_order: 30,
    field_type: 'number',
    placeholder: '20',
    required: true,
    validation: { min: 0, max: 5000 },
    field_path: 'supplement.home_health.caregivers',
    conditions: C,
    tags: ['supplement', 'home_health'],
  },
  {
    id: 'hh_w2_vs_1099',
    text: 'Are caregivers employees (W-2) or independent contractors (1099)?',
    section: 'supplement',
    group: 'hh_employees',
    sort_order: 40,
    field_type: 'select',
    required: true,
    options: [
      { value: 'w2', label: 'All W-2 employees' },
      { value: '1099', label: 'All 1099 contractors' },
      { value: 'mixed', label: 'A mix of both' },
    ],
    field_path: 'supplement.home_health.staff_classification',
    conditions: C,
    tags: ['supplement', 'home_health'],
  },
  {
    id: 'hh_background_checks',
    text: 'Do you run background checks on all staff before they see clients?',
    section: 'supplement',
    group: 'hh_risk',
    sort_order: 50,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.home_health.background_checks',
    conditions: C,
    tags: ['supplement', 'home_health'],
  },
  {
    id: 'hh_licensed',
    text: 'Is the agency licensed/accredited as required by your state?',
    section: 'supplement',
    group: 'hh_risk',
    sort_order: 60,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.home_health.licensed',
    conditions: C,
    tags: ['supplement', 'home_health'],
  },
  {
    id: 'hh_transport_clients',
    text: 'Do staff transport clients in personal or company vehicles?',
    section: 'supplement',
    group: 'hh_operations',
    sort_order: 70,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.home_health.transport_clients',
    conditions: C,
    tags: ['supplement', 'home_health', 'auto'],
  },
  {
    id: 'hh_prior_claims',
    text: 'Any professional liability or abuse/molestation claims in the past 5 years?',
    section: 'supplement',
    group: 'hh_risk',
    sort_order: 80,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.home_health.prior_claims',
    conditions: C,
    tags: ['supplement', 'home_health'],
  },
];
